export default "__VITE_ASSET__be0cc9ac__"